import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

let sceneEnterF: any = null,
    sceneLeaveF: any = null,
    sceneTextEnterF: any = null,
    sceneTextLeaveF: any = null;
export default function F() {
    const { useLang, useRouter, useEffect, useState, gtm, Link, useRef } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('smart_home_panel_2.launch.detail');
    const videoRefPC = useRef();
    const videoRefH5 = useRef();
    const [textEnter, setTextEnter] = useState(false);
    const [showIcon, setShowIcon] = useState(false);

    const [isH5, setIsH5] = useState(false);

    const handleReplay = () => {
        setShowIcon(false);
        if (window?.innerWidth > 1024) {
            if (videoRefPC && videoRefPC.current) {
                videoRefPC.current.currentTime = 0;
                videoRefPC.current?.play();
            }
        } else {
            if (videoRefH5 && videoRefH5.current) {
                videoRefH5.current.currentTime = 0;
                videoRefH5.current?.play();
            }
        }
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            video_name: t('secF_title'),
            position: 'Product Launch_3',
        });
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsH5(window?.innerWidth <= 1024);
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                const video = document.querySelector('.shp2-detail-F .video') as HTMLVideoElement;
                if (video) {
                    if (sceneEnterF) {
                        AniContainer.removeScene(sceneEnterF);
                        sceneEnterF = null;
                    }
                    if (sceneLeaveF) {
                        AniContainer.removeScene(sceneLeaveF);
                        sceneLeaveF = null;
                    }

                    sceneEnterF = AniContainer.create({
                        triggerElement: '.shp2-detail-F .video-box',
                        triggerHook: 1,
                        offset: 270, //video?.offsetHeight / 2,
                        duration: 400,
                        onEnter: () => {
                            setShowIcon(false);
                            if (window?.innerWidth > 1024) {
                                videoRefPC.current?.play();
                            } else {
                                videoRefH5.current?.play();
                            }
                        },
                    });

                    // sceneLeaveF = AniContainer.create({
                    //     triggerElement: '.shp2-detail-F .video',
                    //     triggerHook: 1,
                    //     offset: -100,
                    //     onLeave: () => {
                    //         if (window?.innerWidth > 1024) {
                    //             videoRefPC.current.pause();
                    //             videoRefPC.current.currentTime = 0;
                    //         } else {
                    //             videoRefH5.current.pause();
                    //             videoRefH5.current.currentTime = 0;
                    //         }
                    //     },
                    // });
                }
            };
            resizeAni();
            // window.addEventListener('resize', resizeAni);
            return () => {
                if (sceneEnterF) {
                    AniContainer.removeScene(sceneEnterF);
                    sceneEnterF = null;
                }
                if (sceneLeaveF) {
                    AniContainer.removeScene(sceneLeaveF);
                    sceneLeaveF = null;
                }
                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, [isH5]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (sceneTextEnterF) {
                    AniContainer.removeScene(sceneTextEnterF);
                    sceneTextEnterF = null;
                }
                if (sceneTextLeaveF) {
                    AniContainer.removeScene(sceneTextLeaveF);
                    sceneTextLeaveF = null;
                }
                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                sceneTextEnterF = AniContainer.create({
                    triggerElement: '.shp2-detail-F .text-info',
                    triggerHook: 1,
                    offset: startH,
                    duration: 200,
                    onEnter: () => setTextEnter(true),
                });
            };
            resizeAni();
            // window.addEventListener('resize', resizeAni);
            return () => {
                if (sceneTextEnterF) {
                    AniContainer.removeScene(sceneTextEnterF);
                    sceneTextEnterF = null;
                }
                if (sceneTextLeaveF) {
                    AniContainer.removeScene(sceneTextLeaveF);
                    sceneTextLeaveF = null;
                }

                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, [isH5]);

    return (
        <section className={`shp2-detail-F shp2-detail-section ${css['shp2-detail-F']}`}>
            <div className={`text-info ${textEnter ? 'enter' : ''}`}>
                <h4 className="subtitle">{t('secF_subtitle')}</h4>
                <h2 className="title">{t('secF_title')}</h2>
                <p className="desc">{t('secF_desc')}</p>
            </div>
            <div className="video-box">
                {!isH5 && (
                    <video
                        className="video fullImgs"
                        ref={videoRefPC}
                        src={'/responsive/video/smart-home-panel-2/launch/6_pc.mp4'}
                        // autoPlay
                        // loop
                        muted
                        playsInline
                        preload="auto"
                        width="100%"
                        height="100%"
                        poster="/responsive/picture/smart-home-panel-2/launch/6.jpg"
                        aria-label={t('secF_title')}
                        onEnded={() => setShowIcon(true)}
                    />
                )}
                {isH5 && (
                    <video
                        className="video fullImgs h5"
                        ref={videoRefH5}
                        src={'/responsive/video/smart-home-panel-2/launch/6_h5.mp4'}
                        // autoPlay
                        // loop
                        muted
                        playsInline
                        preload="auto"
                        width="100%"
                        height="100%"
                        poster="/responsive/picture/smart-home-panel-2/launch/6.jpg"
                        aria-label={t('secF_title')}
                        onEnded={() => setShowIcon(true)}
                    />
                )}
                {showIcon && (
                    <svg
                        className="replay-icon"
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={handleReplay}
                    >
                        <rect width="29.9995" height="29.9995" rx="14.9998" fill="#707070" />
                        <path
                            d="M9.54492 8.18164L13.6358 8.18164L13.6358 12.2725"
                            stroke="white"
                            strokeWidth="1.36361"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M17.0445 9.89298C18.2993 10.3351 19.3764 11.173 20.1135 12.2804C20.8507 13.3879 21.208 14.705 21.1315 16.0331C21.0551 17.3613 20.5491 18.6287 19.6897 19.6443C18.8304 20.6599 17.6642 21.3687 16.367 21.6639C15.0698 21.9591 13.7118 21.8247 12.4976 21.2809C11.2834 20.7372 10.2788 19.8136 9.63511 18.6493C8.99146 17.485 8.74364 16.143 8.92899 14.8256C9.11435 13.5082 9.72283 12.2867 10.6628 11.3452L13.6354 8.18164"
                            stroke="white"
                            strokeWidth="1.36361"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                )}
            </div>
        </section>
    );
}
